








































import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import RulesEngineRuleFilterList from '@/components/rules-engine/rule/filter-list.vue';
import RulesEngineOverridesFilterList from '@/components/rules-engine/rule-override/filter-list.vue';
import RulesEngineRuleList from '@/components/rules-engine/rule/list.vue';
import RulesEngineOverridesList from '@/components/rules-engine/rule-override/list.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import {
  RULE_FILTER_TYPE_OVERRIDE,
  RULE_FILTER_TYPE_EMEDE,
} from '@/settings/consts/rules-engine';
import RuleModel from '@/models/rule-model';
import { updateStatusRule } from '@/services/rules-engine';

@Component({
  components: {
    RulesEngineRuleFilterList,
    RulesEngineOverridesFilterList,
    RulesEngineRuleList,
    RulesEngineOverridesList,
    PermissionAuth,
  },
})
export default class RulesEngine extends BaseComponent {
  public filter: any = {};
  public filterType: string = RULE_FILTER_TYPE_EMEDE;
  public filterTypes: any = {
    emede: RULE_FILTER_TYPE_EMEDE,
    override: RULE_FILTER_TYPE_OVERRIDE,
  };

  public filterTypesList: any[] = [
    {
      id: RULE_FILTER_TYPE_EMEDE,
      label: 'Regras',
    },
    {
      id: RULE_FILTER_TYPE_OVERRIDE,
      label: 'Hierarquias',
    },
  ];

  public status = null;
  public itemChanged = null;

  public onFilter(filter: any): void {
    if (!filter) {
      filter = {};
    }
    filter.status = this.status;
    this.filter = Object.assign({}, filter);
  }

  public onChangeStatus(item: RuleModel, newStatus) {
    this.loader.start('Atualizando status...');
    updateStatusRule(item.id, newStatus).subscribe((data) => {
        this.loader.stop();
        this.itemChanged = Object.assign({}, item);
    }, (error) => {
      this.loader.stop();
      this.showToastApiError(error);
    });
  }

  public onAfterSave() {
    this.itemChanged = Object.assign({}, this.itemChanged);
  }
}
